/* c8 ignore start */
import { createSSRApp } from 'vue';
import NotFound from './not-found/NotFound.vue';

export default function createApp() {
  const app = createSSRApp(NotFound);
  return { app };
}
